const Constants = require("./Constants");
const URL = require("url-parse");
const i18n = require("./Internationalization");

var Utils = {};

var SCRIPT_DATA_ATTR = "data-8x8-co-browsing";
var SCRIPT_DATA_MODE_ATTR = "data-8x8-co-browsing-mode";
var SCRIPT_DATA_SERVER_ATTR = "data-8x8-co-browsing-server";
var SCRIPT_DATA_DOMAIN_NAME_ATTR = "data-domain-name";
var SCRIPT_DATA_MULTI_DOMAIN_ATTR = "data-8x8-co-browsing-multi-domain";
var SCRIPT_DATA_SOFTWARE_LANGUAGE_ATTR = "data-8x8-co-browsing-software-language";
var SCRIPT_DATA_POPUP_MODE_ATTR = "data-8x8-co-browsing-popup-mode"; // available || background || none
var SCRIPT_DATA_SCRIPT_TYPE_ATTR = "data-8x8-co-browsing-script-type"; // external || internal

var MODE_LIST = [
  Constants.MODE_FULL_CONTROL,
  Constants.MODE_PARTIAL_CONTROL,
  Constants.MODE_NO_CONTROL
];

var DEFAULT_MODE = Constants.MODE_FULL_CONTROL;

Utils.getBaseURL = function(selfURL) {
  var url;

  if (selfURL) {
    url = window.location.protocol + "//" + window.location.host;

  } else {
    var script = Utils.getCoBrowsingScript();
    url = Utils.getBaseURLFromScriptTag(script);

    if (!url) {
      var parsedURL = Utils.parseURL(script.getAttribute("src"));
      url = parsedURL.protocol + "//" + parsedURL.host;
    }
  }

  return url;
};

Utils.getLicense = function() {
  var script = Utils.getCoBrowsingScript();
  var license = Utils.getLicenseFromURL(script.src);

  return license;
};

Utils.getSoftwareLanguage = function() {
  var script = Utils.getCoBrowsingScript();
  var softwareLanguage = i18n.defaultLanguage || "en-US";

  if (
    script && typeof script.getAttribute === "function" &&
    script.getAttribute(SCRIPT_DATA_SOFTWARE_LANGUAGE_ATTR)
  ) {
    let tempSoftwareLanguage = script.getAttribute(SCRIPT_DATA_SOFTWARE_LANGUAGE_ATTR);

    if (i18n.validateLangCode(tempSoftwareLanguage)) {
      softwareLanguage = tempSoftwareLanguage;
    }
  }

  return softwareLanguage;
};

Utils.getPopupModeFromScriptTag = function(script) {
  const popupMode = script.getAttribute(SCRIPT_DATA_POPUP_MODE_ATTR);

  return popupMode || Constants.POPUP_MODE_AVAILABLE;
};

Utils.getPopupMode = function() {
  const script = Utils.getCoBrowsingScript();
  return Utils.getPopupModeFromScriptTag(script);
};

Utils.getScriptType = function() {
  const script = Utils.getCoBrowsingScript();
  let type = Constants.CO_BROWSING_SCRIPT_TYPE_INTERNAL;

  if (
    script &&
    typeof script.getAttribute === "function"
  ) {
    let scriptType = script.getAttribute(SCRIPT_DATA_SCRIPT_TYPE_ATTR);

    if (scriptType) {
      type = scriptType;
    }
  }

  return type;
};

Utils.getDomainName = function() {
  var script = Utils.getCoBrowsingScript();
  return Utils.getDomainNameFromScriptTag(script);
};

Utils.getCoBrowsingScript = function() {
  var script;

  var scriptList = Utils.getScriptList();

  for (var i = 0, length = scriptList.length; i < length; i++) {
    var coBrowsingData = scriptList[i].getAttribute(SCRIPT_DATA_ATTR);
    if (coBrowsingData) {
      script = scriptList[i];
      break;
    }
  }

  return script;
};

Utils.getLicenseFromURL = function(url) {
  var license = "";
  if (url.indexOf("/license") !== -1) {
    license = url.replace(/.*?\/license(.*?)\/.*$/, "$1");
  }

  return license;
};

Utils.parseURL = function(url) {
  var parsed = document.createElement("a");
  parsed.href = url;

  return parsed;
};

Utils.getScriptList = function() {
  return document.getElementsByTagName("script");
};

Utils.getMode = function() {
  var script = Utils.getCoBrowsingScript();
  return Utils.getModeFromScriptTag(script);
};

Utils.getModeFromScriptTag = function(script) {
  var mode = script.getAttribute(SCRIPT_DATA_MODE_ATTR) || "";

  if (MODE_LIST.indexOf(mode) === -1) {
    mode = DEFAULT_MODE;
  }

  return mode;
};

Utils.getDomainNameFromScriptTag = function(script) {
  return script.getAttribute(SCRIPT_DATA_DOMAIN_NAME_ATTR) || "";
};

Utils.getBaseURLFromScriptTag = function(script) {
  return script.getAttribute(SCRIPT_DATA_SERVER_ATTR) || "";
};

Utils.isMultiDomainEnabled = function() {
  var script = Utils.getCoBrowsingScript();
  return Utils.getMultiDomainEnabledFromScriptTag(script) === "true";
};

Utils.getMultiDomainEnabledFromScriptTag = function(script) {
  return script.getAttribute(SCRIPT_DATA_MULTI_DOMAIN_ATTR) || "";
};

Utils.getReceiverDomainFromURL = function(url) {
  const parsedURL = new URL(url, true);
  return parsedURL.query["receiverDomain"];
};

Utils.isScrollVisible = function(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};

Utils.isElementVisible = function(element) {
  const style = window.getComputedStyle(element);
  return (style.display !== "none");
};

Utils.dispatchEventStatus = function(element, {
  type = "",
  status = ""
}) {
  const event = new CustomEvent(Constants.EVENT_STATUS, {
    detail: {
      status,
      type
    }
  });

  element.dispatchEvent(event);
};

Utils.addResizeListener = function(element, callback) {
  if (!element || typeof callback !== "function") {
    console.warn("Invalid arguments for addResizeListener");
    return;
  }

  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      callback(entry.contentRect);
    }
  });

  resizeObserver.observe(element);

  // Return a function to unobserve the element
  return () => {
    resizeObserver.unobserve(element);
    resizeObserver.disconnect();
  };
};

module.exports = Utils;
